module.exports = __webpack_public_path__ + "img/loader.ec4e5ef5.gif";